import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
export const toggleShowGCContent = createAction("toggleShowGCContent");
export default createReducer(
  {
    [toggleShowGCContent]: (state, val) => {
      localStorage.setItem("showGCContent", val);
      return val;
    }
  },
  window.localStorage.getItem("showGCContent")
);
